import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import DiariosExpo24 from '../../../components/diario/listar/expomacuco';


function DiariosExpo24Screen() {
    return (
        <Fragment>
            <Head titulo="Publicações da Expo Macuco 2024" />
            <Header />
            <Container>
                <DiariosExpo24 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiariosExpo24Screen;